import { useTranslation ,TableComponent,Card} from 'soxo-bootstrap-core';
import React, { useState, useEffect } from 'react';
import { Tag, Table, Select, Skeleton, Input, Radio, Form, Col } from 'antd';
const { TextArea } = Input;
const { Option } = Select;
const formItemLayout = {
    layout: 'vertical',
};
export default function RadiologyResult({ radiologyResponse, onStatusChange,onFieldChange, onRemarksChange, ...props }) {
    const { t, i18n } = useTranslation(); // To Translate to another language
    const [filter, setFilter] = useState('abnormal'); // 'all', 'normal', 'abnormal'
    const [tableData, setTableData] = useState(radiologyResponse); // 'all', 'normal', 'abnormal
    const [form] = Form.useForm();

    useEffect(async () => {
        if (radiologyResponse?.length > 0) await applySelectedFilter('abnormal', radiologyResponse);
    }, [radiologyResponse]);

    async function applySelectedFilter(selectedFilter, radiologyResponse) {
        // Check if there is any data in labResultData

        if (radiologyResponse?.length > 0) {
            // Filter the labResultData based on the selected filter and the result class name
            if (selectedFilter === 'abnormal') {
                radiologyResponse = await radiologyResponse.filter((ele) => {
                    return ele.score === 'C' || ele.score === 'D';     
                });

                setTableData(radiologyResponse);
            } else {
                setTableData(radiologyResponse);
            }
        }
    }

    const handleChange = (value, ele, fieldName) => {
        onFieldChange({ ...ele, [fieldName]: value }, fieldName);
    };
    const columns = [
        {
            title: '#',
            align: 'center',
            render: (value, item, index) => {
                return index + 1;
            },
        
        },
        {
            title: t('Particulars'),
            render: (ele) => {
                return ele.particular;
            },
        },
        {
            title: t('Score'),
            // dataIndex: 'score',
            // key: 'score',
            // width: 500,
            render: (ele) => {
                // return (<div>{ele.score}</div>)
                return (<div><span style={{ color: 'red', fontWeight: 'bold' }}>{ele.score}</span></div>)
                
            },
        },
        {
            title: t('Remarks'),
            key: 'remarks',
            // width: 400,
            render: (ele) => {
                return <div>{ele.remarks}</div>;
            },
        },
        {
            title: t('Comments'),
            key: 'comments',
            render: (ele) => {
                return (
                    <div className="remarks-text">
                        <Form form={form} {...formItemLayout}>
                            <Form.Item name={['comments', ele.itemptr]} initialValue={ele.comments}>
                                <Input
                                 style={{ minWidth:"300px" }} 
                                 onChange={(event) => handleChange(event.target.value, ele, 'comments')}
                                ></Input>
                            </Form.Item>
                        </Form>
                    </div>
                );
            },
        },

        // {
        //     title: t('Status'),
        //     key: 'status',
        //     render: (ele) => {
        //         if (ele.color_code) {
        //             return (
        //                 <>
        //                     {/* <Space size="middle"> {record.modality} </Space> */}
        //                     <Tag color={ele.color_code}>{ele.status}</Tag>
        //                 </>
        //             );
        //         } else {
        //             return ele.status;
        //         }
        //     },
        // },
        
        {
            title: t('Status'),
            key: 'status',
            render: (ele) => {
                return (
                    <div>
                        <Form form={form} {...formItemLayout}>
                            <Form.Item name={['rad_followup_status', ele.itemptr]} initialValue={ele.followup_status}>
                                <Select
                                    style={{ minWidth:"150px" }}
                                    // defaultValue={ele.status_drop_down[0].code}
                                    // value={ele.followup_status}
                                    onChange={(i, values) => {
                                        let selectedValue = values.value
                                        handleChange(selectedValue, ele,"rad_followup_status");
                                    }}
                                    // onChange={(event) => handleChange(event.target.value, ele, 'rad_followup_status')}

                                >
                                    {ele.status_drop_down.map((option) => (
                                        <Option value={option.code}>{option.description}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Form>
                    </div>
                );
            },
        },
       ,{
            title: t('Consultant doctor'),
            key: 'consultant_doctor',
            render: (ele) => {
                // if(ele.followup_remarks)
                // form.setFieldsValue({rad_followup_remark:ele.followup_remarks})
                return (
                    <div className="remarks-text">
                        <Form form={form} {...formItemLayout}>
                            <Form.Item name={['consultant_doctor', ele.itemptr]} initialValue={ele.consultant_doctor}>
                                <Input
                                 style={{ minWidth:"300px" }} 
                                 onChange={(event) => handleChange(event.target.value, ele, 'consultant_doctor')}
                                // onChange={(event) => handleChange(event.target.value, ele, event.target.name)}

                                    // onChange={(event) => {
                                    //     handleChange({ rad_followup_remarks: event.target.value, ...ele });
                                    // }}
                                ></Input>
                            </Form.Item>
                        </Form>
                    </div>
                );
            },
        },{
            title: t('Consultant Hospital'),
            key: 'consultant_hospital',
            render: (ele) => {
                return (
                    <div className="remarks-text">
                        <Form form={form} {...formItemLayout}>
                            <Form.Item name={['consultant_hospital', ele.itemptr]} initialValue={ele.consultant_hospital}>
                                <Input
                                 style={{ minWidth:"300px" }} 
                                 onChange={(event) => handleChange(event.target.value, ele, 'consultant_hospital')}
                                ></Input>
                            </Form.Item>
                        </Form>
                    </div>
                );
            },
        },
        //  {
        //     title: t('Remarks'),
        //     key: 'remarks',
        //     render: (ele) => {
        //         // if(ele.followup_remarks)
        //         // form.setFieldsValue({rad_followup_remark:ele.followup_remarks})
        //         return (
        //             <div className="remarks-text">
        //                 <Form form={form} {...formItemLayout}>
        //                     <Form.Item name={['rad_followup_remark', ele.itemptr]} initialValue={ele.followup_remarks}>
        //                         <Input
        //                          style={{ minWidth:"300px" }} 
        //                             // onChange={(event) => {
        //                             //     handleChange({ rad_followup_remarks: event.target.value, ...ele });
        //                             // }}
        //                             onChange={(event) => handleChange(event.target.value, ele, 'rad_followup_remarks')}

        //                         ></Input>
        //                     </Form.Item>
        //                 </Form>
        //             </div>
        //         );
        //     },
        // }
    ];
    return (
        // <div className="radiology-result-section card">
            <Card className='radiology-result-section'>
            <div>
                <div class="card-header">
                    <div className="card-title">
                        <h3>{t('RADIOLOGY RESULT')}</h3>
                    </div>
                </div>

                {!radiologyResponse? (
                    <Card className="">
                        <Skeleton active />
                    </Card>
                ) : (
                    <>
                        <div>
                            <Radio.Group
                                value={filter}
                                onChange={(e) => {
                                    const selectedFilter = e.target.value;
                                    setFilter(e.target.value);
                                    applySelectedFilter(selectedFilter, radiologyResponse);
                                }}
                            >
                                {/* <Radio.Button value="all">All</Radio.Button> */}
                                <Radio value="abnormal">View C&D Scores</Radio>
                                <Radio value="normal">View All Scores</Radio>
                            </Radio.Group>
                        </div>
                        <div>
                            <TableComponent
                                className="rad-deatils"
                                rowKey={(record, key) => key}
                                pagination={false}
                                scroll={{ x: true}}
                                dataSource={tableData}
                                columns={columns}
                            />
                        </div>
                    </>
                )}
            </div>
            </Card>
        // </div>
    );
}
